import { render, staticRenderFns } from "./CardHeaderBlock.vue?vue&type=template&id=5fd1533a"
import script from "./CardHeaderBlock.vue?vue&type=script&lang=js"
export * from "./CardHeaderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports